module.exports = __webpack_public_path__ + "img/tips-heart.9a9ea530.svg";